module.exports = __webpack_public_path__ + "media/images/boxes/buecherstapel-1bf721fc6aaa2eb0052cac263575912d.jpg";